// extracted by mini-css-extract-plugin
module.exports = {"carousel":"image-carousel_carousel__17v0J","left":"image-carousel_left__1SAyQ","right":"image-carousel_right__ZVFdX","forward":"image-carousel_forward__2dOc6"};